import React from "react";
import PropTypes from "prop-types";

import TableWrapper from "../../shared/bootstrap/TableWrapper";
import Tooltip from "../../shared/mui/Tooltip";

/**
 * FedRamp Product Details Modal Content
 * @param {Object} props
 * @param {FedRampProductViewModel} props.productDetails
 * @param {boolean} props.isLoggedIn
 * @returns {Element}
 * @constructor
 */
export default function ProductDetailsContent({ productDetails, isLoggedIn }) {
  const tooltipTitle = <>
    For more information on this Provider or Product please use the <a className="fedramp-toolTipAnchor"
                                                                       href="/sewp5public/rfitool">SEWP Market
    Research Tool</a>
  </>;

  return (<>
    <h5><strong>{productDetails.productName}</strong></h5>
    <TableWrapper condensed id="fedramp-productViewTable">
      <thead>
      <tr>
        <th className="col-xs-4">Provider</th>
        <th className="col-xs-4">Service Model</th>
        <th className="col-xs-4">Status</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        {productDetails.providerUrl === null || productDetails.providerUrl.indexOf(".") === -1 ?
          <Tooltip title={tooltipTitle}>
            <td>
              <span>
                {productDetails.providerName}
              </span>
            </td>
          </Tooltip> :
          <td>
            <a href={productDetails.providerUrl.replace(/\s/g, "")} target="_blank">
              {productDetails.providerName}
            </a>
          </td>}
        <td>{productDetails.serviceModel}</td>
        <td>{productDetails.status}</td>
      </tr>
      </tbody>
    </TableWrapper>
    {(productDetails.providerSeq > 0 && productDetails.compressedProviderName.toUpperCase() !==
     productDetails.compressedDefaultProviderName.toUpperCase()) && <p className="fedramp-hasAcquired">
       <strong>{productDetails.providerName}</strong> is an affiliate/subsidiary of the
       SEWP <strong>{productDetails.providerDefaultName}</strong>
     </p>}
    <span>
        <div className="fedramp-modalPopUpheading">Agencies/Subagencies</div>
        <br/>
      {productDetails.agencyNames.length === 0 ? <p className="fedramp-nothingFound">No Agency/Subagency to display.</p> : <>
        <ol>
          {productDetails.agencyNames.map((agency) => (<li key={agency.agencyName}>
            &nbsp; {agency.agencyName}
            {agency.subagencyNames.filter(subAgencyName => subAgencyName !== null).length > 0 && <ul>
              {agency.subagencyNames.filter(subAgencyName => subAgencyName !== null)
                     .map((subagencyName) => (<li key={subagencyName}>
                       &nbsp; {subagencyName}
                     </li>))}
            </ul>}
          </li>))}
          <br/>
        </ol>
      </>}
      </span>
    {isLoggedIn && <span>
      <div className="fedramp-modalPopUpheading">Contract Holders</div>
      {productDetails.chNames.length === 0 ? <p className="fedramp-nothingFound">No Contract Holders to display</p> : <ol>
        {productDetails.chNames.map(chName => (<li key={chName}>&nbsp;{chName}</li>))}
      </ol>}
    </span>}
  </>);
}

ProductDetailsContent.propTypes = {
  productDetails: PropTypes.object.isRequired, isLoggedIn: PropTypes.bool.isRequired,
};